module.exports = __webpack_public_path__ + "static/img/77093E_5_6_C_20240604_LC.5ad3352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77093E_5_6_C_20240604_LC.png
// module id = V7cu
// module chunks = 0